import { createApp } from 'vue';
import { createHead } from '@unhead/vue';

import '@unocss/reset/tailwind.css';
import 'virtual:uno.css';

import './auto-generated/brands.css';
import App from './App.vue';
import { StoryblokVue, apiPlugin } from '@storyblok/vue';
import router from '@/router';
// @ts-ignore
import SbRichtext from '@/plugin/sb-richtext/index.js';

const app = createApp(App);
const head = createHead();

app.use(SbRichtext);
app.use(head);
app.use(router);
app.use(StoryblokVue, {
  accessToken: import.meta.env.VITE_STORYBLOK_TOKEN,
  use: [apiPlugin],
});

app.mount('#app');
